import { useEffect, useState } from "react";
import API from "../lib/api";
import { Progress } from "./ui/progress";
import { Circle, CaretRight } from "@phosphor-icons/react";

export const ProfileCompletenessCard = ({ onNavigate, hideWhenComplete = false }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    API.get("/vendor-portal/profile-completeness").then(({ data }) => setData(data)).catch(() => {});
  }, []);

  if (!data) return null;
  if (hideWhenComplete && data.score === 100) return null;
  const missing = data.items.filter((i) => !i.done);

  return (
    <div className="border border-border rounded-lg p-4 bg-card mb-4 sm:mb-6" data-testid="profile-completeness-card">
      <div className="flex items-center justify-between mb-2">
        <p className="text-sm font-semibold font-[Chivo]">Profile completeness</p>
        <span
          className={`text-sm font-bold font-mono ${data.score === 100 ? "text-emerald-600 dark:text-emerald-400" : data.score >= 60 ? "text-amber-600 dark:text-amber-400" : "text-red-500"}`}
          data-testid="completeness-score"
        >
          {data.score}%
        </span>
      </div>
      <Progress value={data.score} className="h-2 mb-3" />
      {data.score === 100 ? (
        <p className="text-xs text-emerald-600 dark:text-emerald-400">Your profile is complete — a full profile wins more work.</p>
      ) : (
        <div className="space-y-1.5">
          <p className="text-xs text-muted-foreground">Complete your profile to win more work — {missing.length} item{missing.length === 1 ? "" : "s"} left:</p>
          {missing.map((i) => (
            <button
              key={i.key}
              type="button"
              onClick={() => onNavigate && onNavigate(i.target)}
              className="w-full flex items-center justify-between text-left px-2 py-1.5 rounded-md border border-border hover:bg-muted/40 transition-colors"
              data-testid={`completeness-item-${i.key}`}
            >
              <span className="flex items-center gap-2 text-xs">
                <Circle size={13} className="text-red-400 shrink-0" />
                {i.label}
                {i.hint ? <span className="text-[10px] text-muted-foreground">· {i.hint}</span> : null}
              </span>
              <CaretRight size={12} className="text-muted-foreground shrink-0" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
